import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { EStampRoutingModule } from './e-stamp-routing.module';
import { SharedModule } from 'src/app/layouts/shared/shared.module';
import { SharedModule as ComponentsSharedModule } from 'src/app/shared/shared.module';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { UiModule } from 'src/app/shared/ui/ui.module';

import { UploadStampExcel } from './upload-stamp-excel/upload-stamp-excel.component';
import { BulkOrdersComponent } from './bulk-orders/bulk-orders.component';
import { CreateCustomerOrderComponent } from './create-customer-order/create-customer-order.component';
import { CustomerOrderListComponent } from './customer-order-list/customer-order-list.component';
import { InventoryComponent } from './inventory/inventory.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { EStampDashboardComponent } from './e-stamp-dashboard/e-stamp-dashboard.component';


@NgModule({
  declarations: [
    UploadStampExcel,
    BulkOrdersComponent,
    CreateCustomerOrderComponent,
    CustomerOrderListComponent,
    InventoryComponent,
    EStampDashboardComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    EStampRoutingModule,
    NgbTooltipModule,
    SharedModule,
    ComponentsSharedModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    UiModule
  ],
  exports: [
    EStampDashboardComponent
  ]
})
export class EStampModule { }
